import { RouteObject } from "react-router-dom";
import { PageNotFound } from "../app/404";
import { AdminLoginPage } from "../app/_admin/auth/login";
import { EventsPage } from "../app/_admin/events";
import { AdminViewSingleEvent } from "../app/_admin/events/view";
import { UsersPage } from "../app/_admin/users";
import { SingleUserPage } from "../app/_admin/users/singleUser";
import { ErrorPage } from "../app/error";
import { AdminAppLayout } from "../components/layout/adminAppLayout";
import { AdminAuthLayout } from "../components/layout/adminAuthLayout";
import { AdminProtected } from "../components/layout/protected";

export const adminRouter: RouteObject[] = [
  {
    path: "/",
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        path: "",
        element: (
          <AdminAuthLayout>
            <AdminLoginPage />
          </AdminAuthLayout>
        ),
      },
      {
        path: "login",
        element: (
          <AdminAuthLayout>
            <AdminLoginPage />
          </AdminAuthLayout>
        ),
      },
      {
        path: "users",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <UsersPage />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "users/:id",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <SingleUserPage />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "events",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <EventsPage />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "events/:id",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <AdminViewSingleEvent />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "events/:id/guest",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <AdminViewSingleEvent guestView />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "revenue",
        element: (
          <AdminAppLayout>
            <AdminProtected>Revennue</AdminProtected>
          </AdminAppLayout>
        ),
      },
    ],
  },

  {
    path: "*",
    element: (
      <AdminAppLayout>
        <PageNotFound />
      </AdminAppLayout>
    ),
  },
];
